// extracted by mini-css-extract-plugin
module.exports = {"area":"UploadPage_area__1art5","label":"UploadPage_label__2rTqd","button":"UploadPage_button__2vBDR"};